/*
bonuses
parse data from rest-api into app-specific format
*/

import view from './view.js';
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import dataflow from '../../common/lib/dataflow.js';

const register = dataflow.register;

const state = {
	selected: {
		id: -1,
		confirmed: false,
		validPaymentMethods: ''
	},
	by_id: null,
	amount_in: null,
	selectedPaymentMethod: null
};

function isEmptyCallback() {
	/* router.js may use this callback to enter next step if no bonuses exist */
}

function shopDepositBonusCallback() {
	/* callback for shop deposit bonus after completing bonus related steps*/
}

function viewUpdate() {
	view.update({
		bonuses: state
	});
}

function viewUpdateForSpinner() {
	view.update({
		completedBonusesFetch: true
	});
}

function bonusesToState(arr) {
	let filled;
	state.by_id = {};
	if (arr && arr.length > 0) {
		/* sort bonuses on bonusid */
		arr.forEach((elm) => {
			if (elm.id) {
				state.by_id[elm.id] = elm;
			} else {
				console.error('bonuses:70:bonusesToState: can not get id from element', elm);
			}
		});
		filled = true;
		state.empty = false;
	} else {
		filled = false;
		state.empty = true;
	}
	return filled;
}

function sortMethodsToState(data = []) {
	const bonuslistFilled = bonusesToState(data);
	viewUpdate();
	actions.bonuses(state);
	return bonuslistFilled;
}

function sortMethodsToStateFreeMoneyBonusSuccess(data = []) {
	const bonuslistFilled = bonusesToState(data);
	view.updateFreeMoneyBonusSucces({
		bonuses: state
	});
	return bonuslistFilled;
}

function parseToStateAmountIn(amount, selectedPaymentMethod) {
	state.amount_in = amount;
	state.selectedPaymentMethod = selectedPaymentMethod;
}

function storeConfirmed() {
	if (state.selected) {
		if (state.selected.confirmed && (state.selected.id && state.selected.id !== -1)) {
			state.bonusid = state.selected.id;
			if (state.by_id && state.by_id[state.bonusid]) {
				state.selected.bonus = state.by_id[state.bonusid];
			}
		}
	} else {
		console.warn('bonuses:69:setSelected: empty property "selected" in state', state);
	}
}

function toPostfix(t) {
	// TODO add unit test to confirm functionality!!
	const noncharacters = new RegExp(/[^a-zA-Z]+/g);
	const str = (t ? t.toString() : '');
	return str.replace(noncharacters, '');
}

function getAnyUnit(arr) {
	/* finds any letters in the input array, and returns the last of them as a unit */
	let unit = null;
	arr.forEach((val) => {
		const lastletters = toPostfix(val);
		if (lastletters && lastletters.length > 0) {
			unit = lastletters;
		}
	});
	return unit;
}

function zeroOutsideLimits(val, min, max) {
	// if value is below min the returned value is zero.
	let adjusted;
	if (state.selectedPaymentMethod) {
		if (!(state.selected.validPaymentMethods.indexOf(state.selectedPaymentMethod.toString()) > -1)) {
			return 0;
		}
	}
	if (min && max) {
		/* return the value if within limits */
		adjusted = (((val >= min) && (val <= max)) ? val : 'check_limit');
		/* if returned value is zero, check against max limit */
		if (adjusted === 'check_limit') {
			if (val < min) {
				adjusted = 0;
			} else if (val >= max) {
				adjusted = max;
			}
		}
	} else if (min && !max) {
		adjusted = ((val >= min) ? val : 0);
	} else if (!min && max) {
		adjusted = ((val <= max) ? val : max);
	} else {
		/* no limits exist */
		adjusted = val;
	}
	return adjusted;
}

function percToValue(val, perc) {
	let value = 0;
	if (perc > 100) {
		console.warn('bonuses:percToValue: bonus larger than 100%', perc);
	}
	if (val && perc) {
		value = (val * perc) / 100;
	}
	return value;
}

function setConditionsMsg() {
	let bonus;
	let msg = '';
	if (state.selected && (state.selected.bonus && state.selected.bonus.bonusPercentage)) {
		bonus = state.selected.bonus;
		msg = (` ->${bonus.bonusPercentage || ''} x ${bonus.minDeposit || ''}-${bonus.maxDeposit || ''}`);
	}
	state.condition = msg;
}

function applyConditions() {
	/* if a percent is set, and min-max values exist, then calculate bonusAmount from amount_in and clamp between limits */
	/* if no rules are applicable return zero */
	const bonus = state.selected.bonus;
	const minDeposit = parseFloat(bonus.minDepositAmount);
	const maxDeposit = parseFloat(bonus.maxDepositAmount);
	const percent = parseFloat(bonus.bonusPercentageValue);
	const bonusAmount = (parseFloat(bonus.bonusAmountValue) || 0);
	/* fixed, preset value */
	const amountIn = parseFloat(state.amount_in);
	let bonusAmountOut = zeroOutsideLimits(amountIn, minDeposit, maxDeposit);
	/* compare input amount to conditions in selected bonus */
	if (bonusAmount) {
		bonusAmountOut = bonusAmount;
	} else if (percent) {
		bonusAmountOut = percToValue(bonusAmountOut, percent);
	}
	state.condition = ` ->${bonus.bonusPercentage || ''} x ${bonus.minDeposit || ''}-${bonus.maxDeposit || ''}`;
	state.amount_out = bonusAmountOut;
	state.currency = getAnyUnit([bonus.minDeposit, bonus.maxDeposit, bonus.bonusAmount]);
	actions.bonuses(state);
	return bonusAmountOut;
}

function setSelectedAndPublishStateForShopDepositBonus(data, selectedBonusId, paymentMethods) {
	bonusesToState(data);
	state.selected.id = selectedBonusId;
	state.selected.validPaymentMethods = paymentMethods;
	state.selected.confirmed = true;
	storeConfirmed();
	applyConditions();
	viewUpdateForSpinner();
}

function setSelected(bonusid, paymentMethods) {
	if (state.selected.id != null && bonusid.toString() === state.selected.id.toString()) {
		/* bonuses:already selected::deselect */
		state.selected.id = -1;
	} else {
		state.selected.id = bonusid;
		state.selected.validPaymentMethods = paymentMethods;
	}
	viewUpdate();
	/* Publish the state */
	actions.bonuses(state);
}

function registerActions() {
	const bonuses = function bonuses(payload) {
		let bonusListIsFilled;
		if (payload.type === constants.FETCH_BONUSES) {
			if (payload.data && payload.data.list) {
				bonusListIsFilled = sortMethodsToState(payload.data.list);
				if (!bonusListIsFilled) {
					isEmptyCallback();
				}
			}
		}
		if (payload.type === constants.FETCH_BONUSES_FREE_MONEY_BONUS_SUCCESS) {
			if (payload.data && payload.data.list) {
				bonusListIsFilled = sortMethodsToStateFreeMoneyBonusSuccess(payload.data.list);
				if (!bonusListIsFilled) {
					isEmptyCallback();
				}
			}
		}
		if (payload.type === constants.VIEW_BONUS) {
			if (payload.data && payload.data.selected) {
				setSelected(payload.data.selected, payload.data.paymentMethods);
			}
			state.selected.confirmed = (payload.data && payload.data.confirmed);
			if (state.selected.confirmed) {
				/* selected bonus is confirmed, keep. */
				/* an amount may be already input into the deposit-action form */
				storeConfirmed();
				applyConditions();
				setConditionsMsg();
				/* Publish the state. */
				actions.bonuses(state);
			}
		}
		if (payload.type === constants.FETCH_BONUSES_FOR_SHOP_DEPOSIT) {
			if (payload.data && payload.data.list) {
				setSelectedAndPublishStateForShopDepositBonus(payload.data.list, payload.selectedBonusId, payload.bonusPaymentMethods);
				shopDepositBonusCallback();
			}
		}
		if (payload.type === constants.VIEW_NAV) {
			/* skipbutton was pressed, deselect all bonuses */
			if (!state.selected.confirmed) {
				state.selected.id = -1;
			}
			/* Publish the state */
			actions.bonuses(state);
			viewUpdate();
		}
		if (payload.type === constants.VIEW_PAYMENTFORM) {
			/* When the depositform is displayed, the input amount can be combined with the selected bonus. */
			if (payload.data && payload.data.amount) {
				parseToStateAmountIn(payload.data.amount, payload.data.selectedPaymentMethod);
				if (state.selected && state.selected.bonus) {
					applyConditions();
				}
			}
		}
		if (payload.type === constants.SUBMIT_PAYMENT) {
			if (payload.success) {
				state.selected.id = null;
			}
		}
	};
	register(bonuses);
}

export default {
	init(p) {
		isEmptyCallback = (p.isEmptyCallback || isEmptyCallback);
		shopDepositBonusCallback = (p.shopDepositBonusCallback || null);
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/bonus/lib/bonuses.js